<template>
  <div
    class="mobile-header"
    v-show="isMobileSite || alwaysShow"
    :style="{ paddingTop: clearHeadPadding ? 0 : statusBarHeight + 'px' }"
  >
    <div
      class="fixed"
      ref="fixed"
      :style="[
        {
          color: customColor || '',
          background: customBackgroundColor || '',
          borderBottom: borderBottom || '1px solid #eee'
        },
        { paddingTop: statusBarHeight + 'px' }
      ]"
    >
      <div class="header-left" v-if="!hideLeft">
        <template v-if="isCancel">
          <span
            class="cancel-btn"
            v-tap="{ methods: goBack, prevPath: prevPath }"
            >取消</span
          >
        </template>
        <template v-else-if="isCustomText">
          <span
            class="cancel-btn"
            v-tap="{ methods: goBack, prevPath: prevPath }"
            v-html="isCustomText"
          ></span>
        </template>
        <template v-else-if="customOpt && customOpt.length > 0">
          <v-touch
            :class="['yxl-font', `yxl-font-${item.icon}`]"
            @tap="item.method"
            v-for="(item, index) in customOpt"
            :key="item.icon"
            :style="{ left: `${index * 44}px` }"
            tag="i"
          ></v-touch>
        </template>
        <template v-else>
          <i
            class="yxl-font yxl-font-back ic-arrow-left"
            v-tap="{ methods: goBack, prevPath: prevPath }"
          ></i>
        </template>
      </div>

      <template>
        <div class="head-middle">
          <h1 v-if="navTitle" class="nav-title">{{ navTitle }}</h1>
          <slot></slot>
        </div>
      </template>

      <template v-if="optBtn">
        <div class="header-right">
          <slot v-if="$slots.optBtnRight" name="optBtnRight"></slot>
          <v-touch
            v-else
            class="opt-btn"
            @tap="headerOpt"
            v-html="optTxt"
          ></v-touch>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import BridgeMixin from 'src/mixins/bridge'
import Bridge from 'src/frontend-lib/lib/Bridge'

export default {
  mixins: [BridgeMixin],

  data() {
    return {
      isMobileSite: false,
      statusBarHeight: 0
    }
  },

  props: [
    'isCancel',
    'isCustomText',
    'navTitle',
    'prevPath',
    'goBack',
    'optBtn',
    'optTxt',
    'headerOpt',
    'customOpt',
    'customColor',
    'customBackgroundColor',
    'borderBottom',
    'alwaysShow',
    'hideLeft',
    'clearHeadPadding'
  ],

  created() {
    var UA = navigator.userAgent
    if (
      UA.indexOf('yixinliApp') >= 0 ||
      UA.indexOf('yixinliConsultationApp') >= 0
    ) {
      this.isMobileSite = false
    } else {
      this.isMobileSite = true
    }
  },

  mounted() {
    if (this.mixinIsApp) {
      this.getBridge().call('hasNotch', {
        callbackName: 'hasNotch'
      })
      new Bridge({
        methods: [
          {
            method: 'hasNotch',
            callback: obj => {
              if (this.canHideNavigationBar) {
                const { hasNotch } = obj
                this.statusBarHeight =
                  hasNotch === 1 || hasNotch === true
                    ? this.platform.isAndroid
                      ? 35
                      : 40
                    : 20
                this.$emit('statusBar', this.statusBarHeight)
              }
            }
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/iconfont/yxl-font.css';
@import '../assets/sass/config';
@import '../assets/sass/function';
@import '../assets/sass/mixin';

.mobile-header {
  width: 100%;
  height: pxToRem(88);
  .fixed {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    max-width: pxToRem(750);
    height: pxToRem(88);
    background-color: #118bd0;
    color: #fff;
    z-index: 12;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: 0.2s;
    .header-left {
      width: pxToRem(88);
      white-space: nowrap;
      .yxl-font {
        display: inline-block;
        width: pxToRem(88);
        height: pxToRem(88);
        line-height: pxToRem(88);
        text-align: center;
      }
    }
    .cancel-btn {
      display: inline-block;
      height: pxToRem(88);
      width: pxToRem(88);
      line-height: pxToRem(88);
      padding-left: pxToRem(24);
      font-size: pxToRem(28);
      box-sizing: border-box;
    }
    .ic-arrow-left {
      display: inline-block;
      height: pxToRem(88);
      width: pxToRem(88);
      background-position: 8px 10px;
      vertical-align: bottom;
    }
    .head-middle {
      flex: 1;
      overflow: hidden;
      .nav-title {
        font-size: pxToRem(34);
        line-height: pxToRem(88);
        text-align: center;
        padding: 0 pxToRem(112);
        overflow: hidden;
        height: pxToRem(88);
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .header-right {
      width: pxToRem(88);
      white-space: nowrap;
      .opt-btn {
        width: pxToRem(88);
        height: pxToRem(88);
        display: inline-block;
        line-height: pxToRem(88);
        padding-right: pxToRem(24);
        font-size: pxToRem(30);
        text-align: right;
        box-sizing: border-box;
      }
    }
    /*.header-search {*/
    /*width: pxToRem(538);*/
    /*height: pxToRem(60);*/
    /*background-color: #ececec;*/
    /*border-radius: 100px;*/
    /*}*/
  }
}
</style>



// WEBPACK FOOTER //
// MobileHeader.vue?3b75e07c